import MainSideBar from "./MainSideBar/MainSideBar"
import SettingsSideBar from "./SettingsSideBar/SettingsSideBar"

export default {
    Main: MainSideBar,
    Settings: SettingsSideBar,
}
